import { render, staticRenderFns } from "./CompanyAgreement.vue?vue&type=template&id=32666c8e&"
import script from "./CompanyAgreement.vue?vue&type=script&lang=js&"
export * from "./CompanyAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports